// src/api/support.js
import client from './client.js';

export const supportAPI = {
  getAll: (params) => client.get('/support', { params }),
  getMy: (params) => client.get('/support/my', { params }),
  getById: (id) => client.get(`/support/${id}`),
  create: (data) => client.post('/support', data),
  update: (id, data) => client.put(`/support/${id}`, data),
  addResponse: (id, data) => client.post(`/support/${id}/response`, data),
  assign: (id, data) => client.put(`/support/${id}/assign`, data),
  close: (id, data) => client.put(`/support/${id}/close`, data),
};